module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMzAgMGMxNi41NjkgMCAzMCAxMy40MzEgMzAgMzAgMCAxNi41NjktMTMuNDMxIDMwLTMwIDMwQzEzLjQzMSA2MCAwIDQ2LjU2OSAwIDMwIDAgMTMuNDMxIDEzLjQzMSAwIDMwIDB6IiBmaWxsPSIjQkVEMEZDIiBvcGFjaXR5PSIuNSIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0zNyAyNC40TDM1LjYgMjMgMzAgMjguNiAyNC40IDIzIDIzIDI0LjRsNS42IDUuNi01LjYgNS42IDEuNCAxLjQgNS42LTUuNiA1LjYgNS42IDEuNC0xLjQtNS42LTUuNnoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.svg
// module id = 886
// module chunks = 0